import { CSSProperties } from 'react';
import { useTheme } from '@mui/material';

interface CountryFlagProps {
  countryCode: string;
  styles?: CSSProperties;
}

export const CountryFlag = ({ countryCode, styles }: CountryFlagProps) => {
  const theme = useTheme();

  if (!countryCode) {
    return null;
  }

  return (
    <span
      className={`fi fi-${countryCode.toLowerCase()}`}
      style={{
        borderRadius: theme.shape.borderRadius,
        marginRight: theme.spacing(1),
        ...styles,
      }}
    />
  );
};
